import { Component, OnInit } from '@angular/core';
import { BrdsqlService } from '../../../services/brdsql.service';

@Component({
  selector: 'app-emp-dashboard',
  templateUrl: './emp-dashboard.component.html',
  styleUrls: ['./emp-dashboard.component.css']
})
export class EmpDashboardComponent implements OnInit {

  empData?: any = [];

  constructor(
    private brdservice: BrdsqlService,
  ) { }

  ngOnInit(): void {
    this.getEmpData()
  }

  // โหลดข้อมูลรายงานสรุปเรื่องพนักงาน
  async getEmpData() {
    this.empData = []
    await this.brdservice.empSummary()
      .subscribe({
        next: (data: any) => {
          this.empData = data.recordset[0];
          console.log('empData: ', this.empData);
        }
      })
    }

}
